module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paginator-wrapper"
  }, [_c('div', {
    staticClass: "paginator hidden-xs"
  }, [(_vm.showFirst) ? _c('router-link', {
    staticClass: "l-rnd",
    attrs: {
      "to": _vm.baseUrl + _vm.query
    }
  }, [_vm._v("«")]) : _vm._e(), _vm._l((_vm.pages), function(page, idx) {
    return [(page !== _vm.curPage) ? _c('router-link', {
      key: 'page-num-' + idx,
      class: _vm.whatClass(idx),
      attrs: {
        "to": _vm.baseUrl + (page !== 1 ? '/' + page : '') + _vm.query
      }
    }, [_vm._v(_vm._s(page))]) : _c('span', {
      key: 'page-num-active-' + idx,
      class: _vm.whatClass(idx)
    }, [_vm._v(_vm._s(page))])]
  }), (_vm.showLast) ? _c('router-link', {
    staticClass: "r-rnd arr-last",
    attrs: {
      "to": _vm.baseUrl + '/' + _vm.lastPage + _vm.query
    }
  }, [_vm._v("»")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "paginator visible-xs-inline"
  }, [(_vm.showMobileFirst) ? _c('router-link', {
    staticClass: "l-rnd",
    attrs: {
      "to": _vm.baseUrl + _vm.query
    }
  }, [_vm._v("«")]) : _vm._e(), (_vm.showPrev) ? _c('router-link', {
    attrs: {
      "to": _vm.baseUrl + '/' + (_vm.curPage - 1) + _vm.query
    }
  }, [_vm._v("←")]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.curPage))]), (_vm.showNext) ? _c('router-link', {
    attrs: {
      "to": _vm.baseUrl + '/' + (_vm.curPage + 1) + _vm.query
    }
  }, [_vm._v("→")]) : _vm._e(), (_vm.showMobileLast) ? _c('router-link', {
    staticClass: "r-rnd arr-last",
    attrs: {
      "to": _vm.baseUrl + '/' + _vm.lastPage + _vm.query
    }
  }, [_vm._v("»")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e979b6d0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/paginator.vue
// module id = 502
// module chunks = 0